/* global google */

import React from "react";
import styles from "./Autocomplete.module.scss";
import axios from "axios";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

class Autocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.autocomplete = null;
    this.autocompleteInput = React.createRef();
    this.valuePlaceholder = "";
    this.maxSuggestions = 5;
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.autoCompleteParams !== prevProps.autoCompleteParams &&
      this.props.autoCompleteParams !== undefined
    ) {
      if (
        this.props.autoCompleteParams &&
        this.props.autoCompleteParams.noBias
      ) {
        this.setState({
          types: ["geocode", "establishment"],
          autocompleteInput: React.createRef(),
        });
      } else if (
        this.props.autoCompleteParams &&
        this.props.autoCompleteParams.autoCompleteBias &&
        this.props.autoCompleteParams.autoCompleteBias.southwest &&
        this.props.autoCompleteParams.autoCompleteBias.northeast
      ) {
        const southwest = {
          lat: this.props.autoCompleteParams.autoCompleteBias.southwest[0],
          lng: this.props.autoCompleteParams.autoCompleteBias.southwest[1],
        };
        const northeast = {
          lat: this.props.autoCompleteParams.autoCompleteBias.northeast[0],
          lng: this.props.autoCompleteParams.autoCompleteBias.northeast[1],
        };

        this.setState({
          types: ["geocode", "establishment"],
          locationBounds: new google.maps.LatLngBounds(southwest, northeast),
          autocompleteInput: React.createRef(),
        });
      } else {
        // This should theoretically never get hit, but on the off-chance it does, we want to use global values.
        this.setState({
          types: ["geocode", "establishment"],
          autocompleteInput: React.createRef(),
        });
      }
    }
  };

  _handleInputChange = (e) => {
    this.props.onChange(e);
    if (e.target.value.length > 2) {
      if (!this.props.disableGoogleSuggestionList) {
        _.debounce(() => {
          this.loadSuggestedPlaces(e.target.value, (predictions) => {
            this.props.onPlaceChanged(predictions);
          });
        }, 500)();
      }
    } else {
      this.props.onPlaceChanged([]);
    }
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      var customPlace = this.props.autoCompleteCustomPlaces?.find(
        (element) =>
          element.name.toLowerCase() === event.target.value.toLowerCase()
      );
      if (customPlace === undefined) {
        this.loadSuggestedPlaces(event.target.value, (predictions) => {
          if (predictions && predictions.length > 0) {
            this.props.setPrediction(predictions[0]);
          }
        });
      } else {
        this.props.setPrediction({
          customPlace: true,
          title: customPlace.description,
          latitude: customPlace.latitude,
          longitude: customPlace.longitude,
        });
      }
    }
  };

  getCoordinates = (coordinates) => {
    const match = coordinates.match(
      /^\s*([-+]?\d{1,2}(?:\.\d+)?),\s*([-+]?\d{1,3}(?:\.\d+)?)\s*$/
    );
    if (!match) return null;

    const [latitude, longitude] = [parseFloat(match[1]), parseFloat(match[2])];
    if (
      latitude >= -90 &&
      latitude <= 90 &&
      longitude >= -180 &&
      longitude <= 180
    ) {
      return { latitude: latitude, longitude: longitude };
    } else {
      return null;
    }
  };

  // Loads the suggested locations, and passes them back using a callback.
  loadSuggestedPlaces = (forValue, resultCallback) => {
    var valueCoordinates = this.getCoordinates(forValue);
    if (valueCoordinates) {
      resultCallback([
        {
          latitude: valueCoordinates.latitude,
          longitude: valueCoordinates.longitude,
          title: forValue,
          isCoordinates: true,
        },
      ]);
    } else if (this.props.suggestionSource === "google") {
      this.loadGoogleSuggestedPlaces(forValue, resultCallback);
    } else if (
      this.props.suggestionSource === "hereApi" ||
      this.props.suggestionSource === "photon"
    ) {
      this.loadAutoSuggestedPlaces(forValue, resultCallback);
    }
  };

  // Loads the suggested locations using google, and passes them back using a callback.
  loadGoogleSuggestedPlaces = (forValue, resultCallback) => {
    const options = {
      input: forValue,
    };

    if (this?.state?.types) {
      options.types = this.state.types;
    }
    if (this?.state?.locationBounds) {
      options.bounds = this.state.locationBounds;
    }

    this.props.autocompleteService.getPlacePredictions(
      options,
      (googlePredictions, status) => {
        if (status === "OK" && googlePredictions) {
          const limitedPredictions = googlePredictions.slice(
            0,
            this.maxSuggestions
          );

          const formattedPredictions = limitedPredictions.map((prediction) => ({
            title: prediction.structured_formatting.main_text,
            description: prediction.description,
            placeId: prediction.place_id,
          }));

          resultCallback(formattedPredictions);
        } else if (status !== "ZERO_RESULTS") {
          console.error(`Place prediction failed: ${status}`);
          resultCallback([]);
        } else {
          resultCallback([]);
        }
      }
    );
  };

  // Loads the suggested locations using the here api, and passes them back using a callback.
  loadAutoSuggestedPlaces = (forValue, resultCallback) => {
    var target;

    if (
      this.props.autoCompleteParams.autoCompleteBias &&
      this.props.autoCompleteParams.autoCompleteBias.centrepoint
    ) {
      target = `${this.props.autoCompleteParams.autoCompleteBias.centrepoint[0]},${this.props.autoCompleteParams.autoCompleteBias.centrepoint[1]}`;
      console.log("Target ", target);
    } else if (
      this.props.autoCompleteParams.autoCompleteBias &&
      this.props.autoCompleteParams.autoCompleteBias.southwest &&
      this.props.autoCompleteParams.autoCompleteBias.northeast
    ) {
      // Use the bounding box in the group settings to decide the autocomplete bias.
      var bias = this.props.autoCompleteParams.autoCompleteBias;
      target = `bbox:${bias.southwest[1]},${bias.southwest[0]},${bias.northeast[1]},${bias.northeast[0]}`;
      console.log("target is bbox");
    } else {
      // Use the center of the current viewport to decide the autocomplete bias.
      var approxLoc = this.props.suggestionApproximateLocation;
      target = `${approxLoc.latitude},${approxLoc.longitude}`;
      console.log("target is centrepoint of viewpoint");
    }

    axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `autosuggest/${forValue}/${target}/${this.props.destinationGroupId}`,
        {
          headers: {
            Authorization: this.props.apiToken,
          },
        }
      )
      .then((response) => {
        var predictions = response.data.map((autosuggestPrediction) => ({
          title: autosuggestPrediction.title,
          description: autosuggestPrediction.address.label,
          latitude: autosuggestPrediction.position.lat,
          longitude: autosuggestPrediction.position.lng,
          id: autosuggestPrediction.id,
          groupName: autosuggestPrediction.groupName,
          stopPointType: autosuggestPrediction.stopPointType,
        }));
        resultCallback(predictions);
      })
      .catch((e) => {
        console.error("Error loading suggestions:", e);
        resultCallback([]);
      });
  };

  render = () => {
    var isAutoCompleteActivated =
      this.props.value &&
      this.autocompleteInput &&
      this.autocompleteInput.current &&
      this.autocompleteInput.current.value;
    var isValueUpdatingRequired =
      isAutoCompleteActivated &&
      this.autocompleteInput.current.value !== "" &&
      this.autocompleteInput.current.value !== this.props.value;

    if (isValueUpdatingRequired) {
      this.autocompleteInput.current.value = this.props.value;
    }

    return (
      <>
        <FormattedMessage id="enterLocation">
          {(placeholder) => (
            <input
              ref={this.autocompleteInput}
              aria-label={this.props.arialabel}
              type="search"
              id={this.props.id}
              name={this.props.name}
              value={this.props?.value ? this.props.value : ""}
              placeholder={this.props.valuePlaceholder || placeholder}
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              className={styles["form-input"]}
              onBlur={this.props.onBlur}
              onFocus={this.props.onFocus}
              onClick={this.props.onClick}
              onChange={this._handleInputChange}
              onKeyDown={this.handleKeyPress}
            />
          )}
        </FormattedMessage>
      </>
    );
  };
}

export default Autocomplete;
